//Vishy 2025-02-23: This file was originally known as RewardsRedeem.tsx. The file is now renamed as "Redemption Verification"

import {
  Box,
  Button,
  Divider,
  HStack,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Header from "../../Components/Common/Header";
import { Images } from "../../Assets/images";
import FAQModal from "../../Components/Modals/FAQModal";
import { Modal } from "antd";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { BuyerInterface } from "../../Interface/CommonInterface";
import { useNavigate } from "react-router-dom";

type Props = {};

const RedemptionVerification = (props: Props) => {
  const navigate = useNavigate();

  const [isModal, setIsModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rewardStatements, setRewardStatements] = useState<any[]>([]);
  const [redemptions, setRedemptions] = useState<any[]>([]);
  const [redemptionsSummary, setRedemptionsSummary] = useState<any[]>([]);
  const [redeemablePoints, setRedeemablePoints] = useState<number>(0);
  const [buyer, setBuyer] = useState<BuyerInterface>();

  const getRewardsAndEvents = async () => {
    try {
      setLoading(true);
      const res2 = await BuyerAPI.getBuyerProfile();
      if (res2) {
        const params: any = {};
        params["buyerId"] = res2.data.data._id;
        setBuyer(res2.data.data);
        const [data1, data2] = await Promise.all([
          BuyerAPI.getRewardsByBuyerId(params),
          BuyerAPI.getRedemptionsSummary(params),
        ]);
        if (data1) {
          setRewardStatements(data1.data.data.rewards);
        }
        if (data2) {
          setRedemptions(data2.data.data);
        }
      }
    } catch (err: any) {
      console.log(err);
    } finally {
      // setLoading(false);
    }
  };

  const handleOpenModal = () => setIsModal(true);
  const handleCloseModal = () => setIsModal(false);
  useEffect(() => {
    if (rewardStatements.length > 0) {
      setRedeemablePoints(rewardStatements[0].closingBalance);
    }
  }, [rewardStatements]);
  
  useEffect(() => {
    getRewardsAndEvents();
  }, []);
  
  const FAQButton = () => {
    return (
      <AiOutlineQuestionCircle
        style={{
          position: "absolute",
          right: "0px",
          top: "0px",
          height: "36px",
          width: "36px",
        }}
        // onClick={handleOpenModal}
        onClick={() => {
          window.open("https://prontocommerce.com/aftr/rewards/", "_blank");
        }}
      />
    );
  };
  const sendRedeemRequest = async () => {
    try {
      const res = await BuyerAPI.requestRedemption({
        buyerId: buyer?._id,
      });
      console.log("redemption result for rrid structure",res);
      if (res) {
        navigate(`/buyer/redemption/${res?.data?.redemptionRequestId}`); //Vishy 2025-02-24 changed from rewardsRedemption?. to Redemption?.
      }
    } catch (err) {
      console.log(err);
    }
  };
  const onClosePopUp = () => {
    navigate(`/buyer/rewards`);
  }
  return (
    <Box p={6} display={"flex"} flexDir={"column"}>
      <Modal
        footer={null}
        title={null}
        open={isModal}
        onCancel={handleCloseModal}
        closeIcon={null}
        onOk={handleCloseModal}
      >
        <FAQModal handleCloseModal={handleCloseModal} />
      </Modal>
      <Header backButton righticon={FAQButton} onClosePopUp={onClosePopUp}>
        Redemption
      </Header>
      <Divider
        mt={5}
        borderWidth="6px"
        opacity={"1"}
        borderColor={"primary.main"}
      />
      <Box p={6} maxW="800px" mx="auto">
        <VStack spacing={6} align="flex-start">
          <Text fontSize={"sm"}>
            The rewards program is subject to T&Cs.
          </Text>
          <Text fontSize={"sm"}>
            Reward points are redeemable against gift vouchers (issued via
            email).
          </Text>
          <Text fontSize={"sm"}>
            Once a redemption is initiated, a “Redemption Id” is generated to
            track status.
          </Text>
          <Text fontSize={"sm"}>
            Technical support on redemption related issues is available at
            <Link
              href="mailto:support@aftr.network"
              isExternal
              textDecoration={"underline"}
            >
              {" "}
              support@aftr.network
            </Link>
            .
          </Text>
        </VStack>
      </Box>
      <Box
        mt={5}
        py={10}
        // bg={"#22121927"}
        bg={"#0013BC"}
        bgImage={Images.RewardsBanner}
        rounded={"18px"}
      >
        <Text
          fontSize={"36px"}
          color={"white"}
          textAlign={"center"}
          fontWeight={"semibold"}
        >
          You will receive Gift Vouchers for your {redeemablePoints} reward points.
        </Text>
      </Box>
      <Box p={6} maxW="800px" mx="auto">
        <Text fontSize={"sm"}>I accept these <Text
            as={"span"}
            cursor={"pointer"}
            onClick={() => {
              // window.location.href = "https://prontocommerce.com/eula-after";
              window.open("https://prontocommerce.com/aftr/rewards/", "_blank");
            }}
            color={"blue"}
          >Terms and Conditions</Text></Text>
      </Box>
      <HStack justifySelf={"end"} margin={"0px auto"} gap={3}>
        <Button
          flex={1}
          size={"md"}
          p={"0px 20px"}
          bg={"rgb(255, 95, 18)"}
          color={"#fff"}
          onClick={sendRedeemRequest}
        >
          Redeem Now
        </Button>
        <Text
          onClick={() => {
            navigate(-1);
          }}
        >
          Do it Later.
        </Text>
      </HStack>
    </Box>
  );
};

export default RedemptionVerification
